// Monthly.kz web portal — environment configuration.
//
// Each value resolves in priority order:
//   1. window.__ENV__   — runtime config injected by /env.js, regenerated at
//      container start by infrastructure/40-monthly-env.sh. Lets ONE
//      monthly-web image serve both staging and prod.
//   2. import.meta.env  — Vite build-time vars (local `vite dev`, `.env`).
//   3. hard-coded localhost defaults.
//
// Two base URLs are exposed because authenticated and guest endpoints live at
// different path roots:
//   - API_URL      — includes `/api` suffix, used by `client.ts`
//   - API_BASE_URL — no `/api` suffix, used by `guestClient.ts` (guest routes
//     are registered under `/guest/*` in routes/web.php).

declare global {
  interface Window {
    __ENV__?: Partial<
      Record<
        | 'VITE_API_URL'
        | 'VITE_API_BASE_URL'
        | 'VITE_REVERB_APP_KEY'
        | 'VITE_REVERB_HOST'
        | 'VITE_REVERB_PORT'
        | 'VITE_REVERB_SCHEME',
        string
      >
    >;
  }
}

const runtimeEnv = (typeof window !== 'undefined' && window.__ENV__) || {};

/** Pick the runtime value, else the Vite build-time value, else the fallback. */
function pick(
  runtime: string | undefined,
  buildTime: string | undefined,
  fallback: string,
): string {
  if (runtime && runtime.length > 0) return runtime;
  if (buildTime && buildTime.length > 0) return buildTime;
  return fallback;
}

export const API_URL: string = pick(
  runtimeEnv.VITE_API_URL,
  import.meta.env.VITE_API_URL,
  'http://localhost:8080/api',
);

export const API_BASE_URL: string = pick(
  runtimeEnv.VITE_API_BASE_URL,
  import.meta.env.VITE_API_BASE_URL,
  'http://localhost:8080',
);

export const REVERB_APP_KEY: string = pick(
  runtimeEnv.VITE_REVERB_APP_KEY,
  import.meta.env.VITE_REVERB_APP_KEY,
  'monthly-reverb-key',
);

export const REVERB_HOST: string = pick(
  runtimeEnv.VITE_REVERB_HOST,
  import.meta.env.VITE_REVERB_HOST,
  'localhost',
);

export const REVERB_PORT: number = Number(
  pick(runtimeEnv.VITE_REVERB_PORT, import.meta.env.VITE_REVERB_PORT, '8080'),
);

export const REVERB_SCHEME: string = pick(
  runtimeEnv.VITE_REVERB_SCHEME,
  import.meta.env.VITE_REVERB_SCHEME,
  'http',
);

export const STORAGE_KEYS = {
  authToken: 'monthly.auth.token',
  authUser: 'monthly.auth.user',
  locale: 'monthly.locale',
} as const;
